<template>
	<section id="status" class="s-status">
		<div class="overlay"></div>

		<div class="row section-header" data-aos="fade-up">
			<div class="col-full">
				<h3 class="subhead" v-html="$t('titles.statusMonitoring')"></h3>
				<h1 class="display-2" v-html="$t('texts.statusInfo')"></h1>
			</div>
		</div>

		<div class="row status-content" data-aos="fade-up">
			<h4 v-html="$t('titles.statusSchedule')"></h4>
			<p v-html="$t('texts.statusSchedule')"></p>
		</div>

		<div class="row status-content" data-aos="fade-up">
			<h4 v-html="$t('titles.statusModString')"></h4>
			<div class="alert-box alert-box--info">
				<span class="nobr">-mod=</span><span class="nobr">@CUP_Terrains_Core;</span><span class="nobr">@CUP_Terrains_Maps;</span><span class="nobr">@RHSGREF;</span><span class="nobr">@RHSSAF;</span><span class="nobr">@RHSUSAF;</span><span class="nobr">@RHSAFRF;</span><span class="nobr">@WOG_ACE;</span><span class="nobr">@WOG_Mods;</span><span class="nobr">@WOG_BAF;</span><span class="nobr">@WOG_BW;</span><span class="nobr">@WOG_Islands;</span><span class="nobr">@YuEmod;</span><span class="nobr">@TFAR;</span><span class="nobr mod-highlight">@WOG_Extra;</span>
			</div>

			<div class="mt-2 text">
				<p class="color-white" v-html="$t('texts.statusWogExtra')"></p>
			</div>
		</div>

		<div class="row status-content" data-aos="fade-up">
			<h4 v-html="$t('titles.statusCredentials')"></h4>

			<div class="status-container" v-if="Object.keys(credentials).length">
				<div class="status-item">
					<div class="status-item-icon"><span><i class="fas fa-server"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusServer')"></div>
					<div class="status-item-value"><a v-bind="{href: armaUrl()}" v-text="armaServer()"></a></div>
				</div>

				<div class="status-item">
					<div class="status-item-icon"><span><i class="fab fa-teamspeak"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusTeamspeak')"></div>
					<div class="status-item-value"><a v-bind="{href: teamspeakUrl()}" v-text="teamspeakServer()"></a></div>
				</div>

				<div class="status-item">
					<div class="status-item-icon"><span><i class="fas fa-download"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusFtp')"></div>
					<div class="status-item-value"><a v-bind="{href: this.$store.state.statusCredentials['primaryFtpAddress']}" v-text="this.$store.state.statusCredentials['primaryFtpAddress']"></a></div>
				</div>
			</div>
			<div class="alert-box alert-box--error" v-else v-html="$t('texts.statusNoData')"></div>
		</div>

		<div class="row status-content" data-aos="fade-up">
			<h4 v-html="$t('titles.statusServer')"></h4>

			<div class="status-container" v-if="Object.keys(server).length && ('online' in server) && server['online']">
				<div class="status-item">
					<div class="status-item-icon"><span><i class="fas fa-male"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusPlayers')"></div>
					<div class="status-item-value">{{ server['players'] }}</div>
				</div>

				<div class="status-item">
					<div class="status-item-icon"><span><i class="fas fa-globe"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusIsland')"></div>
					<div class="status-item-value" v-text="(server['world'].length ? $t('islands.' + server['world'].toLowerCase()) : $t('islands.none'))"></div>
				</div>

				<div class="status-item">
					<div class="status-item-icon"><span><i class="fas fa-quote-left"></i></span></div>
					<div class="status-item-text" v-html="$t('tables.statusMission')"></div>
					<div class="status-item-value">{{ server['map'] }}</div>
				</div>
			</div>
			<div class="alert-box alert-box--error" v-else v-html="$t('texts.statusOffline')"></div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'SectionStatus',
		computed: {
			// server object
			server: {
				/**
				 * Get features array.
				 * @return {Array} features array
				 */
				get: function() {
					return this.$store.state.statusServer;
				},

				/**
				 * Update features array.
				 */
				set: function() {
					this.$store.dispatch('statusServerUpdate', 6);
				}
			},

			// credentials object
			credentials: {
				/**
				 * Get features array.
				 * @return {Array} features array
				 */
				get: function() {
					return this.$store.state.statusCredentials;
				},

				/**
				 * Update features array.
				 */
				set: function() {
					this.$store.dispatch('statusCredentialsUpdate', 6);
				}
			}
		},
		methods: {
			/**
			 * Generate full WOG Arma server IP.
			 * @return {String} full server IP
			 */
			armaServer: function() {
				// server ip
				let server = this.$store.state.statusCredentials['ipAddress'];

				// add port if needed
				if (('gamePort' in this.$store.state.statusCredentials) && String(this.$store.state.statusCredentials['gamePort']).length) {
					server += ':' + String(this.$store.state.statusCredentials['gamePort']);
				}

				// result
				return server;
			},



			/**
			 * Generate url for connecting to WOG Arma server.
			 * @return {String} url
			 */
			armaUrl: function() {
				// url
				let url = 'steam://rungameid/107410// -nolauncher -mod=@CUP_Terrains_Core;@CUP_Terrains_Maps;@RHSGREF;@RHSSAF;@RHSUSAF;@RHSAFRF;@WOG_ACE;@WOG_Mods;@WOG_BAF;@WOG_Islands;@WOG_BW;@YuEmod;@TFAR; -password=wogames';

				// add server
				url += ' -connect=' + this.$store.state.statusCredentials['ipAddress'];

				// add port
				if (('gamePort' in this.$store.state.statusCredentials) && String(this.$store.state.statusCredentials['gamePort']).length) {
					url += ' -port=' + String(this.$store.state.statusCredentials['gamePort']);
				}

				// result
				return url;
			},



			/**
			 * Generate full teamspeak server address.
			 * @return {String} full server address
			 */
			teamspeakServer: function() {
				// server address
				let address = this.$store.state.statusCredentials['tsAddress'];

				// add port if needed
				if (('tsPort' in this.$store.state.statusCredentials) && String(this.$store.state.statusCredentials['tsPort']).length) {
					address += ':' + String(this.$store.state.statusCredentials['tsPort']);
				}

				// result
				return address;
			},


			/**
			 * Generate url for connecting to teamspeak server.
			 * @return {String} url
			 */
			teamspeakUrl: function() {
				// url
				let url = 'ts3server://';

				// add address
				url += this.$store.state.statusCredentials['tsAddress'];

				// add port
				if (('tsPort' in this.$store.state.statusCredentials) && String(this.$store.state.statusCredentials['tsPort']).length) {
					url += '?port=' + String(this.$store.state.statusCredentials['tsPort']);
				}

				// result
				return url;
			}
		},
		created: function() {
			// update server object
			this.$store.dispatch('statusServerUpdate', 6);

			// update credentials object
			this.$store.dispatch('statusCredentialsUpdate', 6);

			// update server status every 10 seconds
			const _this = this;
			setInterval(function() {
				_this.$store.dispatch('statusServerUpdate', 6);
			}, 10000);

			// update credentials every 1 minute
			setInterval(function() {
				_this.$store.dispatch('statusCredentialsUpdate', 6);
			}, 60000);
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/sections/Status.vue